<template>
  <widget
    @closed="$emit('closed')"
    @search="openSearch"
    @add="addNote()"
    title="Note"
    icon="mdi-note-multiple"
    :bgColor="colors.blue"
    dark
    addButton
    searchButton
    scroll
  >
    <v-row v-if="searchBtn" class="px-3 my-3 mx-0 search-bar">
      <v-text-field
        class="mx-1"
        label="Ricerca rapida"
        clearable
        v-model="search"
      ></v-text-field>
    </v-row>
    <v-card
      v-for="(item, index) in filteredList"
      :key="index"
      solo
      class="px-1 ma-2 d-flex note"
      elevation="3"
      color="amber lighten-4"
    >
      <v-textarea
        style="font: menu"
        clear-icon="mdi-close-circle"
        counter
        class="pa-0 ma-0"
        color="grey darken-2"
        :hint="`${item.createdDate ? $options.filters.dateFormat(item.createdDate) : ''} ${item.createdByFirstName ? item.createdByFirstName : ''} ${item.createdByLastName ? item.createdByLastName : ''}`"
        persistent-hint
        placeholder="Inserisci la tua nota."
        rows="3"
        v-model="item.testo"
      ></v-textarea>
      <v-btn
        class="pa-0 ma-0"
        @click="saveNoteSelected(item)"
        fab
        dark
        x-small
        icon
        :color="colors.primarycolor"
      >
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        x-small
        icon
        class="pa-0 ma-0"
        @click="deleteSelected(item.id)"
        color="red"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-card>
  </widget>
</template>

<script>
import Widget from "./Widget.vue";
import { mapActions, mapGetters } from "vuex";
import mixin from "@/mixin";

export default {
  name: "note",
  mixins: [mixin],
  components: {
    Widget,
  },

  mounted() {
    this.fetchData();
  },
  data() {
    return {
      texto: null,
      searchBtn: false,
      search: "",
    };
  },
  methods: {
    async deleteSelected(item) {
      await this.deleteNote(item);
      this.fetchData();
    },
    async saveNoteSelected(item) {
      await this.saveNote(item);
      this.fetchData();
    },
    ...mapActions({
      fetchData: "widget/fetchNotes",
      deleteNote: "widget/deleteNote",
      saveNote: "widget/saveNote",
      addNote: "widget/addNote",
    }),
    openSearch() {
      this.searchBtn = !this.searchBtn;
      this.search = "";
    },
  },
  computed: {
    ...mapGetters({
      items: "widget/notes",
    }),

    filteredList() {
      return this.items.filter((item) =>
        item.testo
          .trim()
          .toLowerCase()
          .includes(this.search.toLowerCase().trim())
      );
    },
  },
};
</script>

<style >
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  transition: opacity 0.2s ease;
}
</style>